import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Phase, ProjectV2 } from '@app/interfaces';
import { PipesModule } from '@app/pipes';
import { TruncateTextPipe } from '@app/pipes/truncate-text/truncate-text.pipe';
import { RedirectService } from '@app/services';

@Component({
  selector: 'mnf-pi-v2-description',
  standalone: true,
  imports: [CommonModule, PipesModule],
  templateUrl: './pi-v2-description.component.html',
  styleUrl: './pi-v2-description.component.scss'
})
export class PiV2DescriptionComponent implements OnInit {
  @Input() infoProject: ProjectV2;
  @Input() phase: Phase;

  isTextTruncated = false;
  showFullText = false;
  truncatedText = '';
  fullText: any;
  restDayTotal: number;
  isBrowser: boolean;
  browserContainer: boolean;

  constructor(
    private dom: DomSanitizer,
    private redirectService: RedirectService,
    @Inject(PLATFORM_ID) private platformId,
  ) { this.isBrowser = isPlatformBrowser(this.platformId) }

  @ViewChild('textContainer') textContainer: ElementRef<HTMLElement>;
  buttonText = '...Leer más';
  isExpanded = false;

  ngOnInit(): void {
    if(this.isBrowser){
      this.checkScreenSize();
    }
    setTimeout(() => {
      let generalDescription = this.infoProject?.newProject?.sectionInformation?.descriptionResume;
      if(generalDescription) {
        this.infoProject.description = generalDescription
      }
      const pipe = new TruncateTextPipe();
      const result = pipe.transform(this.infoProject?.description, 350);
      this.truncatedText = result.text;
      this.fullText = this.convertHTML(this.infoProject?.description);
      this.isTextTruncated = result.isTruncated;
      this.restDayTotal = this.calcuateRestDay(this.phase?.maxDateToInvest);
    }, 500)
  }

  convertHTML(html: string) {
    return this.dom.bypassSecurityTrustHtml(html);
  }

  calcuateRestDay(dateLimit: number) {
    const dateNow = new Date();
    const dateEnd = new Date(Number(dateLimit));
    const diffTime = dateEnd?.getTime() - dateNow.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if(Number.isNaN(diffDays) || diffDays < 0 || diffDays == null || diffDays == undefined) {
      return 60;
    } else {
      return diffDays;
    }
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
    this.buttonText = this.isExpanded ? 'Leer menos' : '...Leer más';
    if (this.isExpanded) {
      this.textContainer.nativeElement.classList.add('expanded');
    } else {
      this.textContainer.nativeElement.classList.remove('expanded');
    }
  }

  toggleFullText() {
    this.showFullText = !this.showFullText;
  }

  getProjectStateText(state: string): string {
    const stateTextMap = {
      'variable': 'Rendimiento variable',
      'fixed': 'Rendimiento fijo',
    };
  
    return stateTextMap[state] || 'Rendimento variable';
  }

  getLetterClass(): string{
    let letter: string = this.infoProject?.ratingProject;
    const letterPrefix = letter?.match(/^[A-Za-z]+/)?.[0] || '';
    const letterMap: { [key: string]:string } = {
      'B': 'rb-pos',
      'MB': 'mb-pos',
      'M': 'rm-pos',
      'A': 'ra-pos',
    };
    return letterMap[letterPrefix] || '';
  }

  openLink(url: string) {
    this.redirectService.openURL(url);
  }

  checkScreenSize(){
    if(!this.isBrowser) return;
    const isLargeScreen = window.innerWidth >= 992;
    if(isLargeScreen){
      this.browserContainer = true;
    }else{
      this.browserContainer = false;
    }
  }
  
}
